import { HSActiveConfiguration } from './hs-active-configuration';

export class SlidingDoorActiveConfiguration extends HSActiveConfiguration {
    type: 'sliding_door' = 'sliding_door';
}
